import script from "./MassTransfertsContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./MassTransfertsContent.vue?vue&type=script&setup=true&lang=ts"

import "./MassTransfertsContent.vue?vue&type=style&index=0&id=55cff98b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55cff98b"]])

export default __exports__